import React, { useEffect, useRef } from 'react';

interface VisibilityObserver {
  children: React.ReactElement;
  on_fully_visible: () => void;
  threshold: number;
  intersection_ratio: number;
  className?: string;
}

function VisibilityObserverCmp({
  children,
  on_fully_visible,
  threshold,
  intersection_ratio,
  className,
}: Readonly<VisibilityObserver>): React.ReactElement {
  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= intersection_ratio) {
          on_fully_visible();
        }
      },
      {
        threshold: threshold,
      },
    );

    observer.observe(element);

    return () => observer.unobserve(element);
  }, [on_fully_visible]);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}

export default VisibilityObserverCmp;
